import * as React from "react";

import {ConversionContextProvider, enums} from "@repo/analytics-learning-time";

import DigitalSatLandingPage from "../pages/digital-sat-landing-page.tsx";

import {withStrings} from "./locales/digital-sat-landing-page-container/load-strings.tsx";

function DigitalSatLandingPageContainer(
    props: JSX.LibraryManagedAttributes<
        typeof DigitalSatLandingPage,
        React.ComponentProps<typeof DigitalSatLandingPage>
    >,
): React.ReactElement {
    return (
        <ConversionContextProvider
            learningTimeInfo={{
                activity: enums.Activity.OTHER_ACTIVITY,
                product: enums.Product.TEST_PREP,
                testPrep: {
                    exam: enums.Exam.DIGITAL_SAT,
                    examGroup: enums.ExamGroup.SAT_GROUP,
                },
            }}
        >
            <DigitalSatLandingPage {...props} />
        </ConversionContextProvider>
    );
}

export default withStrings(DigitalSatLandingPageContainer);
